export const orderChatQueryKeys = {
  all: ["chat"] as const,
  byOrder: (orderId: number) => ["chat", "order", orderId] as const,
  messages: (chatId: number) => ["chat", "messages", chatId] as const,
  unreadSummary: (customerId: number) => ["chat", "unread-summary", customerId] as const,
};
